import { getAxiosClient } from './common';

const axios = getAxiosClient();

export async function validateToken() {
  const { data } = await axios({
    method: 'GET',
    url: `/v1/auth/validateToken`,
  });
  return data;
}

export async function getAuthCode(email: string, redirectUri?: string) {
  const { data } = await axios({
    method: 'POST',
    url: `/v3/auth/getAuthCode`,
    data: { email, redirectUri, source: 'web' },
  });

  return data;
}

/**
 * Login response shape — how the client distinguishes bearer from cookie mode without reading the
 * flag (single source of truth = the server's response): a `token` means legacy bearer auth;
 * `{ email, userId }` with no token means the server set the HttpOnly cookie and returned the hint.
 * TODO(INFRA-218): always the hint variant once cookie auth is the only web path.
 */
export type LoginResponse =
  | { token: string; email?: undefined; userId?: undefined }
  | { token?: undefined; email: string; userId: string };

export async function login(email: string, code: string): Promise<LoginResponse> {
  const { data } = await axios({
    method: 'POST',
    url: `/v3/auth/login`,
    data: { email, code, source: 'web' },
  });

  return data;
}

interface RegisterProps {
  firstName: string;
  lastName: string;
  email: string;
  companyName: string;
  phone?: string;
}

export async function register(data: RegisterProps) {
  return await axios({
    method: 'POST',
    url: `/v3/auth/register`,
    data,
  });
}

interface JoinProps {
  firstName: string;
  lastName: string;
  email: string;
}

export async function join(body: JoinProps) {
  const { data } = await axios({
    method: 'POST',
    url: `/v3/auth/getAuthCode`,
    data: {
      ...body,
      source: 'web',
    },
  });
  return data;
}

export async function logOut({ email }: { email: string }) {
  const { data } = await axios({
    method: 'POST',
    url: `/v3/auth/logOut`,
    data: { email },
  });
  return data;
}

export async function getPylonSsoUrl(redirectUri?: string) {
  const { data } = await axios({
    method: 'GET',
    url: `/v1/auth/pylon-sso`,
  });
  const { pylonSsoToken, pylonCallbackUrl } = data;
  if (redirectUri) {
    const separator = redirectUri.includes('?') ? '&' : '?';
    return `${redirectUri}${separator}access_token=${pylonSsoToken}`;
  }
  return `${pylonCallbackUrl}&access_token=${pylonSsoToken}`;
}

export async function joinOrgByDomain(organizationId: string) {
  const response = await axios({
    method: 'POST',
    url: `/v3/auth/joinOrgByDomain`,
    data: { organizationId },
  });

  return { status: response.status, data: response.data };
}
